/*eslint-disable*/
import React, { useContext, useEffect, useState } from "react";
import { FirebaseContext } from "common";
import { features, language } from "config";
import { useDispatch, useSelector } from "react-redux";
import CircularLoading from "../../components/CircularLoading";
import MaterialTable from "material-table";
import Material_React_Table from "../../components/React_Material_Table/Material_React_Table";
import { Box } from "@mui/material";
export default function ReferralDoctors() {
  const { api } = useContext(FirebaseContext);
  const {
    updateRefDoctor,
    deleteRefDoctor,
    checkUserExists,
    editReferralDrType
  } = api;
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [practices, setPractices] = useState({});
  const usersdata = useSelector((state) => state.doctors);
  const referraldoctors = useSelector(
    (state) => state.referraldoctors.referraldrs
  );

  const doctortypes = useSelector((state) => state.doctortypes.doctortypes);
  const specialities = useSelector(
    (state) => state.specialitytypes.specialities
  );
  const [specialityTypes, setSpecialityTypes] = useState(null);
  const [doctorTypes, setDoctorTypes] = useState(null);
  const [state, setState] = useState({
    userType: "nurse",
    firstName: "",
    lastName: "",
    referralId: "",
    practiceNumber: "",
    practiceName: "",
    practiceLicenseNumber: "",
    specialityType: "Default",
    bankAccount: "",
    bankCode: "",
    bankName: "",
    bankType: "",
    licenseImage: null,
    doctorImage: null,
    nurseImage: null,
    other_info: "",
    password: "",
    email: ""
  });
  // refrral doctors to return
  useEffect(() => {
    if (referraldoctors) {
      let ref = referraldoctors.filter((doctor) => {
        if (doctor.practiceNumber === auth.info.profile.practiceNumber) {
          return doctor;
        }
      });

      setData(ref);
    } else {
      if (referraldoctors !== null) {
        setData(referraldoctors);
      }
    }
  }, [referraldoctors]);

  useEffect(() => {
    if (specialities) {
      let obj = {};
      for (let i = 0; i < specialities.length; i++) {
        specialities.map((speciality) => (obj[speciality] = speciality));
      }
      setSpecialityTypes(obj);
    }
    if (doctortypes) {
      let arr = {};
      for (let i = 0; i < doctortypes.length; i++) {
        doctortypes.map((doctypes) => (arr[doctypes] = doctypes));
      }
      setDoctorTypes(arr);
    }
  }, []);

  const columns = [
    { header: language.first_name, accessorKey: "firstName", initialEditValue: "" },
    { header: language.last_name, accessorKey: "lastName", initialEditValue: "" },
    {
      header: language.email,
      accessorKey: "email",
      editable: "onAdd",
      render: (rowData) =>
        features.AllowCriticalEditsAdmin ? rowData.email : "Hidden for Demo"
    },
    {
      header: language.mobile,
      accessorKey: "mobile",
      editable: "onAdd",
      render: (rowData) =>
        features.AllowCriticalEditsAdmin ? rowData.mobile : "Hidden for Demo"
    },
    {
      header: "Practice Name",
      accessorKey: "practiceName",
      initialEditValue: "",
      editable: "never",
      render: (rowData) =>
        auth.info.profile.practiceName
          ? rowData.practiceName
          : auth.info.profile.practiceName
    },
    {
      header: "Practice Number",
      accessorKey: "refferalPracticeNumber",
      initialEditValue: ""
    },
    { header: "DoctorType", accessorKey: "doctorTypes", lookup: doctorTypes },
    { header: "Speciality", accessorKey: "specialityTypes", lookup: specialityTypes },
    { header: language.other_info, accessorKey: "other_info", initialEditValue: "" },
    {
      header: language.referralId,
      accessorKey: "referralId",
      editable: "never",
      initialEditValue: ""
    }
  ];

  const      onRowAdd= (newData) =>{
          new Promise((resolve, reject) => {
            setTimeout(() => {
              checkUserExists(newData).then((res) => {
                if (res.users && res.users.length > 0) {
                  alert(language.user_exists);
                  reject();
                } else if (res.error) {
                  alert(language.email_or_mobile_issue);
                  reject();
                } else {
                  newData["createdByAdmin"] = true;

                  newData["createdAt"] = new Date().toISOString();
                  newData["referralId"] =
                    newData.firstName.toLowerCase() +
                    Math.floor(1000 + Math.random() * 9000).toString();
                  setState({
                    ...state,
                    newData
                  });
                  let role = auth.info.profile.userType;
                  if (role === "practiceadmin") {
                    newData["practiceadmin"] = auth.info.uid;
                    newData["practiceNumber"] =
                      auth.info.profile.practiceNumber;
                  }
                  if (role === "nurse") {
                    newData["nurse"] = auth.info.uid;
                    newData["practiceNumber"] =
                      auth.info.profile.practiceNumber;
                  }
                  if (role === "doctor") {
                    newData["doctor"] = auth.info.uid;
                    newData["practiceNumber"] =
                      auth.info.profile.practiceNumber;
                  }
                  dispatch(editReferralDrType(newData, "Add"));
                  console.log("newData", newData);
                  resolve();
                }
              });
            }, 600);
          });

        };
           const   onRowUpdate=(newData, oldData) =>{
          new Promise((resolve) => {
            setTimeout(() => {
              resolve();
              dispatch(updateRefDoctor(oldData.id, newData));
            }, 600);
          })
        };
       const onRowDelete= (oldData) =>{
          features.AllowCriticalEditsAdmin
            ? new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  dispatch(deleteRefDoctor(oldData.id));
                }, 600);
              })
            : new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  alert(language.demo_mode);
                }, 600);
              })
            };

  return usersdata.loading ? (
    <CircularLoading />
  ) : (
     <Box>
       {/* <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
         {commonAlert.msg}
       </AlertDialog> */}
       <Material_React_Table
         data={data}
         columns={columns}
         userInitialState={{
           columnVisibility: { id: false }, // This hides the "id" column initially
         }}
         onRowAdd={onRowAdd}
         onRowUpdate={onRowUpdate}
         onRowDelete={onRowDelete}
       />
     </Box>
  );
}
